import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

import router from './router'
import store from './store'
import axios from './helpers/axios';
import i18n from './i18n'
import VeeValidate from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps'
import DatetimePicker from 'vuetify-datetime-picker'
import CKEditor from '@ckeditor/ckeditor5-vue2';



import VMdDateRangePicker from "v-md-date-range-picker";

import CountryCodeSelect from 'vue-country-code'
import VueCountryCode from "vue-country-code-select";

Vue.use(VueCountryCode);
Vue.component('country-code-select', CountryCodeSelect)

Vue.use(VMdDateRangePicker);

Vue.use(VeeValidate);
Vue.use(CKEditor); 
Vue.use(DatetimePicker);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBE1s-LuOOBxhJEaXiVYBrWgd0TwGJv3so',
    // key: 'AIzaSyACmr0esxW0X5DtoHqZ1sfbfPoVFDD2BRo',

    libraries: 'places',
  }
});

Vue.config.productionTip = false

Vue.prototype.$axios = axios;

Vue.prototype.$vuetify = vuetify;

Vue.prototype.$store = store;

Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_URL;

new Vue({  
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
